export const STRIKE_PRICES = [100000, 330000, 420000, 690000, 1000000];
